// Form validation for New Project form
import { isEmpty } from 'lodash';
import { plaintextValidator } from '../fields';
import { stringMandateConstraints } from '../utils';

const config = { mandatory: true };

export default {
  name: plaintextValidator(config),
  metrics: {
    array: {
      name: stringMandateConstraints,
      attribute: stringMandateConstraints,
      metricFunction: stringMandateConstraints,
      'filterCondition.operands': {
        array: {
          operands: {
            array: {
              operator: { presence: { allowEmpty: false } },
              value: function(
                value,
                attributes,
                attributeName,
                options,
                constraints
              ) {
                const exceptedOperators = ['isEmpty', 'isNotEmpty'];
                if (!(typeof value === 'boolean')) {
                  if (exceptedOperators.includes(attributes?.operator)) {
                    return null;
                  }
                  return { presence: { allowEmpty: false } };
                }
                return { presence: { allowEmpty: false } };
              }
            }
          }
        }
      }
    }
  },
  groupBy: {
    dynamicArray: {
      attribute: {
        presence: { allowEmpty: false }
      },
      unit: {
        presence: { allowEmpty: false }
      }
    }
  }
};
